import * as React from "react";
import * as ReactDOM from "react-dom";

import { Provider } from "react-redux";
import { store } from "reducers";

import 'assets/style/App.scss';
import 'assets/style/output.css'

import App from "./App";

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("adminapp")
);